import { action } from 'satcheljs';
import type { OWAConnectedAccount, AccountProviderType } from 'owa-accounts-store';

/**
 * Announces when user clicks on remove account
 */
export const startRemovingAccount = action(
    'startRemovingAccount',
    (
        account: OWAConnectedAccount,
        mergeViewEnabledAccount: string,
        isReconnectFlow: boolean = false
    ) => ({
        account,
        mergeViewEnabledAccount,
        isReconnectFlow,
    })
);

/**
 * starts adding the new account for given provider type
 */
export const startAddingAccount = action(
    'startAddingAccount',
    (accountProviderType: AccountProviderType, isReconnectFlow: boolean = false) => ({
        accountProviderType,
        isReconnectFlow,
    })
);

export const updatingTrueTime = action('updatingTrueTime', (userIdentity: string) => ({
    userIdentity,
}));

export const resetAccountsEditorStore = action('resetAccountsEditorStore');
